import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckIcon } from '@yonderland/andes-icons';
import { Box, IconButton, ListBox, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
const NewLanguagePopover = ({ currentLang, alternateUrl }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const isCurrentLang = (language) => language === currentLang;
    const getLabel = (language) => `${t(`language.${language}`)} (${language.toUpperCase()})`;
    return (_jsx(ListBox, { children: _jsx(ListBox.Group, { children: Object.keys(alternateUrl)
                .sort((a, b) => Number(isCurrentLang(b)) - Number(isCurrentLang(a)))
                .map((lang, index) => {
                return (_jsxs(ListBox.Item, { paddingBlock: "3", testId: `${index}-${lang}`, state: isCurrentLang(lang) ? 'selected' : 'enabled', href: alternateUrl[lang], children: [_jsx(Box, { contentAlign: "center", children: _jsx(TextAlpha, { strong: true, variant: "bodyM", color: "emphasised", children: getLabel(lang) }) }), isCurrentLang(lang) && (_jsx(IconButton, { variant: "plain", icon: { source: CheckIcon, size: 'sm', color: 'emphasised' }, size: "sm" }))] }, lang));
            }) }) }));
};
export default NewLanguagePopover;
